
function testimonialSlider() {

    jQuery(document).ready(function ($) {

        $('.component--testimonials').each(function () {
            const slider = $(this).find('.testimonials-splide')[0];

            if (slider) {
                new Splide(slider, {
                    // autoScroll: {
                    //     speed: 1,
                    //     pauseOnHover: true,
                    //     pauseOnFocus: false,
                    // },
                    // extensions: { AutoScroll: Splide.Extensions.AutoScroll },
                }).mount();
            }
        });

    })

}

export default testimonialSlider;